<template>
  <div>
    <component-header
      title="Edit User"
      :hasSearch="false"
      :hasReload="false"
      :hasCreate="false"
      :hasback="true"
      @back-press="$router.push('/user')"
    />
    <b-card>
      <div>
        <h3 class="mx-3" style="color: #727cf5">User Information</h3>
        <b-row>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text p-2">
                First Name :
                <b-form-input
                  inputType="text"
                  inputId="FirstName"
                  placeholder="Enter Name"
                  v-model="currentUser.name.first"
                  class="mt-0"
                />
              </h5>
              <h5 class="h5-text p-2">
                Email :
                <b-form-input
                  inputType="text"
                  inputId="Email"
                  placeholder="Enter Email"
                  v-model="currentUser.email"
                  class="mt-0"
                />
              </h5>
              <h5 class="h5-text p-2">
                Education :
                <b-form-input
                  inputType="text"
                  inputId="Education"
                  placeholder="Enter Education"
                  v-model="currentUser.education"
                  class="mt-0"
                ></b-form-input>
              </h5>
              <b-row>
                <b-col md="7">
                  <h5 class="h5-text p-2">
                    Working Experience :
                    <b-form-input
                      inputType="number"
                      inputId="Experience"
                      placeholder="Enter Working Experience"
                      v-model="currentUser.experience.value"
                      class="mt-0"
                    />
                  </h5>
                </b-col>
                <b-col md="5">
                  <h5 class="h5-text p-1">
                    Uom :
                    <eb-select
                      type="text"
                      :selected="currentUser.experience.uom"
                      v-model="currentUser.experience.uom"
                      :options="['Days', 'Months', 'Years']"
                      label="label"
                      placeholder="UOM"
                    ></eb-select>
                  </h5>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text p-2">
                Last Name :
                <b-form-input
                  inputType="text"
                  inputId="LastName"
                  placeholder="Enter Last Name"
                  v-model="currentUser.name.last"
                  class="mt-0"
                />
              </h5>
              <h5 class="h5-text p-2">
                Gender :
                <eb-select
                  type="text"
                  v-model="currentUser.gender"
                  :selected="currentUser.gender"
                  :options="['Female', 'Male', 'Others']"
                  label="label"
                  placeholder="Select Gender"
                ></eb-select>
              </h5>
              <h5 class="h5-text p-2">
                DOB :
                <b-form-input
                  id="activation-date"
                  type="date"
                  v-model="currentUser.dob"
                ></b-form-input>
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text p-2">
                Phone Number :
                <c-tel-input
                  v-model="currentUser.phone"
                  :defaultInput="currentUser.phone"
                  class="m-0"
                />
              </h5>
              <h5 class="h5-text p-2">
                Marital Status :
                <eb-select
                  type="text"
                  :selected="currentUser.maritalStatus"
                  v-model="currentUser.maritalStatus"
                  :options="['Single', 'Married']"
                  label="label"
                  placeholder="Select Marital Status"
                ></eb-select>
              </h5>
              <h5>Profile Photo:</h5>
              <div style="margin-left: 86px; margin-top: -25px">
                <single-image
                  height="150px"
                  width="130px"
                  @change="(d) => uploadImage('profilePhoto', d)"
                  :id="'profilePhoto'"
                  :url="currentUser.profilePhoto"
                  label="Browse Profile Photo"
                ></single-image>
              </div>
            </div>
          </b-col>
        </b-row>
        <hr style="border-top: 1px dashed #727cf5" class="mt-2" />
        <h3 class="mx-3" style="color: #727cf5">User Address</h3>
        <b-row>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text p-2">
                City :
                <b-form-input
                  type="text"
                  inputId="city"
                  v-model="currentUser.city"
                  placeholder="Enter City"
                />
              </h5>
              <h5 class="h5-text p-2">
                Zipcode :
                <b-form-input
                  inputType="number"
                  inputId="zipcode"
                  v-model="currentUser.zip"
                  placeholder="Enter Zipcode"
                />
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text p-2">
                State :
                <b-form-input
                  type="text"
                  inputId="state"
                  v-model="currentUser.state"
                  placeholder="Enter State"
                />
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text p-2">
                Country :
                <b-form-input
                  type="text"
                  inputId="state"
                  v-model="currentUser.country"
                  placeholder="Enter Country"
                />
              </h5>
            </div>
          </b-col>
        </b-row>
        <hr style="border-top: 1px dashed #727cf5" class="mt-2" />
        <h3 class="mx-3" style="color: #727cf5">User Access</h3>
        <b-row>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text p-2">
                User Name :
                <b-form-input
                  type="text"
                  inputId="userName"
                  v-model="currentUser.userName"
                  placeholder="Enter User Name"
                />
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text p-2">
                Category :
                <b-form-input
                  type="text"
                  inputId="category"
                  readonly
                  v-model="currentUser.category"
                  placeholder="Enter Access Level"
                />
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text p-2" v-if="$userRole == 'Tenant'">
                Access Level :
                <b-form-input
                  type="text"
                  inputId="orgAccessLevel"
                  readonly
                  v-model="currentUser.orgAccessLevel"
                  placeholder="Enter Access Level"
                />
              </h5>
            </div>
          </b-col>
        </b-row>
        <hr style="border-top: 1px dashed #727cf5" class="mt-2" />
        <h3 class="mx-3" style="color: #727cf5">Other Information</h3>
        <b-row>
          <b-col md="12">
            <div class="mx-3">
              <h5 class="h5-text p-2">
                About Me:
                <textarea
                  id="AboutMe"
                  rows="3"
                  cols="40"
                  style="border: 1px solid grey"
                  inputType="text"
                  v-model="currentUser.aboutMe"
                ></textarea>
              </h5>
            </div>
          </b-col>
        </b-row>
        <hr style="border-top: 1px dashed #727cf5" class="mt-2" />
        <template>
          <b-button
            size="sm"
            class="mr-2 my -0 main-navigation-button mx-3"
            variant="primary"
            v-b-modal.modal-1
            @click="kycByUser"
          >
            KYC Details
          </b-button>
          <b-modal id="modal-1" scrollable size="lg" centered ok-only>
            <b-row v-if="isloading">
              <b-col md="12" class="text-center">
                <h4>Loading....</h4>
              </b-col>
            </b-row>
            <b-row
              class="px-5 py-2"
              v-else-if="kycUser && kycUser.documents && kycUser.documents.length"
            >
              <b-col
                md="8"
                class="justify-content-center"
                :key="i"
                v-for="(kyc, i) in kycUser.documents"
              >
                <b-row>
                  <h5 class="h5-text p-2">
                    {{ kyc.docType }} :
                    <span class="span-text">{{ kyc.docuementNo }}</span>
                  </h5>
                </b-row>
                <b-row
                  ><h5 class="h5-text">
                    Document Type :
                    <span class="span-text">{{ kyc.docType }}</span>
                  </h5></b-row
                >
                <b-row>
                  <h5 class="h5-text p-2">Photo :</h5>
                </b-row>
                <b-row>
                  <b-col md="6">
                    <a target="_blank" :href="kyc.frontSideFilePath">
                      <img :src="kyc.frontSideFilePath" height="200px" width="200px" />
                    </a>
                    <label>Front Side</label>
                  </b-col>
                  <b-col md="6">
                    <a target="_blank" :href="kyc.backSideFilePath">
                      <img :src="kyc.backSideFilePath" height="200px" width="200px" />
                    </a>
                    <label>Back Side</label>
                  </b-col>
                </b-row>

                <hr />
              </b-col>
            </b-row>
            <b-row
              class="px-5 py-2"
              v-if="kycUser && kycUser.documents && kycUser.documents.length"
              ><b-col>
                <button
                  type="button"
                  class="btn btn-lg btn-outline-primary ml-3 w-25"
                  @click="updateKyc()"
                >
                  Update KYC
                </button>
              </b-col></b-row
            >
            <b-row v-else>
              <b-col md="12" class="text-center">
                <h4>Kyc Data Not Found</h4>
                <button
                  type="button"
                  class="btn btn-lg btn-outline-primary ml-3 w-25"
                  @click="createKyc()"
                >
                  Create KYC
                </button>
              </b-col>
            </b-row>
          </b-modal>
        </template>
      </div>
      <div class="text-center mb-5 mt-5">
        <button
          type="button"
          class="btn btn-lg btn-outline-success ml-3 w-25"
          @click.prevent="handleSubmit"
        >
          Update
        </button>
      </div>
    </b-card>
  </div>
</template>
<script>
import { getReverseGeoCode } from "@/services/geocode";
import cTelInput from "@/components/Common/MobileNumberInput";
import ComponentHeader from "@/components/componentHeader";
import ebSelect from "@/components/FormElements/Select";
import ebButton from "@/components/FormElements/Button";
import { mapActions, mapGetters } from "vuex";
import SingleImage from "../../components/Common/Image.vue";
import Vue from "vue";
export default {
  name: "Edituser",
  components: {
    ebButton,
    SingleImage,
    cTelInput,
    ComponentHeader,
    ebSelect,
  },
  data() {
    return {
      isloading: false,
      currentUser: {
        name: {
          first: "",
          last: "",
        },
        email: "",
        phone: "",
        gender: "",
        experience: {
          value: "",
          uom: "",
        },
        maritalStatus: "",
        education: "",
        dob: "",
        profilePhoto: "",
        address: {
          state: "",
          city: "",
          country: "",
          zip: "",
        },
        authentication: {
          userName: "",
        },
        aboutMe: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      kycUser: "tenant/GetKycByUser",
    }),
  },
  methods: {
    createKyc() {
      this.$router.push({ name: "CreateKyc", params: { userData: this.currentUser } });
    },
    updateKyc() {
      this.$router.push({
        name: "UpdateKyc",
        params: { userData: this.currentUser, kycData: this.kycUser.documents },
      });
    },
    showCustomToast() {
      Vue.toasted.show("Uploading...", {
        type: "info",
        theme: "toasted-primary",
        singleton: true,
        duration: 1000000,
      });
    },
    clearCustomToast() {
      Vue.toasted.clear();
    },
    async uploadImage(path, image) {
      let dataobj = {
        image: image,
        key: (
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
        ).toLowerCase(),
        isPublic: true,
        replaceExisting: true,
        basePath: ["agent", "profilePhoto"],
      };
      this.showCustomToast();
      await this.$store
        .dispatch("inventory/uploadImageToStorage", dataobj)
        .then((res) => {
          this.clearCustomToast();
          this.currentUser[path] = res.data.fileUrl;
        })
        .catch((error) => {
          this.clearCustomToast();
          this.$toasted.error("Image not uploaded..please try again!");
        });
    },
    handleSubmit() {
      const data = {
        _id: this.currentUser._id,
        payload: {
          name: {
            first: this.currentUser.name.first,
            last: this.currentUser.name.last,
          },
          email: this.currentUser.email,
          phone: this.currentUser.phone,
          gender: this.currentUser.gender,
          education: this.currentUser.education,
          profilePhoto: this.currentUser.profilePhoto,
          authentication: {
            userName: this.currentUser.authentication.userName,
          },
          dob: this.currentUser.dob,
          experience: {
            value: this.currentUser.experience.value,
            uom: this.currentUser.experience.uom,
          },
          aboutMe: this.currentUser.aboutMe,
          maritalStatus: this.currentUser.maritalStatus,
          address: {
            state: this.currentUser.address.state,
            city: this.currentUser.address.city,
            country: this.currentUser.address.country,
            zip: this.currentUser.address.zip,
          },
        },
      };
      this.$store.dispatch("partner/updateUser", data).then(() => {
        this.$swal({
          title: "Success",
          text: "User updated successfully!!",
          type: "success",
        });
        this.$router.push("/user");
      });
    },
    async kycByUser() {
      this.isloading = true;
      const data = await this.$store
        .dispatch("tenant/fetchKYCListByUser", {
          id: this.currentUser._id,
        })
        .then((res) => {});
      this.isloading = false;
    },
  },
  mounted: async function () {
    this.loading = true;
    Object.assign(this.currentUser, this.$route.params.userData);
    this.loading = false;
  },
};
</script>

<style scoped>
.card {
  border-width: inherit;
  border-radius: 2px;
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
}

[col-4="image"] {
  background-color: aliceblue !important;
}

[btn-back="primary"] {
  background-color: #727cf5 !important;
  margin: 0px;
  height: 41px;
  color: white;
}
</style>
<style>
.footer-bottons-class {
  text-align: center;
  background: #727cf5 !important;
  margin-left: 40%;
}
.span-text {
  font-size: 15px;
  font-weight: normal;
  line-height: 24px;
}
.h5-text {
  font-size: 15px;
  line-height: 17px;
}
</style>
